<template>
  <div class="diagram  row-center">
    <div class="box">
      <div class="title">
        <span>电池电量</span>
      </div>
      <div class="cont">
        <Charts id="chartOption2" :option="chartOption1" v-if="!chartShow"></Charts>
        <div v-else class="row-center not_found_data">
          <img src="../../../assets/img/not_found_data.png" alt="">
        </div>
      </div>
    </div>
    <div class="box">
      <div class="title row-center">
        <span>充放电统计</span>
        <div class="tag">
          <label :class="{ active: range == 'hour' }" @click="range = 'hour'">日</label>
          <label :class="{ active: range == 'week' }" @click="range = 'week'">周</label>
          <label :class="{ active: range == 'day' }" @click="range = 'day'">月</label>
        </div>
      </div>
      <div class="cont">
        <Charts id="chartOption1" :option="chartOption2" v-if="!chartShow"></Charts>
      </div>
    </div>
  </div>
</template>
<script>
import Charts from "../../../components/common/Charts.vue";
import {dayStart, dayEnd,getLastOrNextFewDateBy} from "../../../util/DateUtil";
import {inverterTotalLine, photovoltaicReport} from '../../../api/power'
import dayjs from "dayjs";

export default {
  data() {
    return {
      range:"hour",
      temp: [],
      SevenPower: [],
      GenerateList: {
        timeArr: [],
        valArr: []
      },
      chartShow: false,
      barWidth: 15
    };
  },
  components: {
    Charts
  },

  computed: {
    chartOption1() {
      let temp = []
      for (let i = 0; i <= 24; i++) {
        temp.push(i + "点")
      }
      let arr = [40, 80, 120, 160, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 120, 40, 40, 40 ]
      let hour = new Date().getHours() + 1
      let seriesData = arr.splice(0,hour)
      return {
          grid: {
              left: "0%",
              right: "3%",
              bottom: "4%",
              top: "15%",
              containLabel: true,
          },
          
          tooltip: {
              trigger: 'axis'
          },
          xAxis: {
              type: 'category',
              boundaryGap: false,
              data:temp
          },
          yAxis: {
              type: 'value',
              name:"剩余电量",
              nameTextStyle:{
                  padding: [0,0 ,0,24],
                  fontSize:"16rem",  
                  color:"#333"
              }
          },
          series: [
              {
                  name: '今日',
                  data:  seriesData,
                  type: 'line',
                  smooth: true,
                  itemStyle: {
                      color: '#0D94FF'
                  },
                  areaStyle: {
                      color:{
                          type: 'linear',
                          x: 0,
                          y: 0,
                          x2: 0,
                          y2: 1,
                          colorStops: [{
                              offset: 0, color: 'rgba(58,132,255, 0.4)' // 0% 处的颜色
                          }, {
                              offset: 1, color: 'rgba(58,132,255, 0)' // 100% 处的颜色
                          }],
                          global: false // 缺省为 false
                      }
                  }
              },
              
          ]
      }
    },
    chartOption2() {
      let xData = getLastOrNextFewDateBy(new Date())
      return {
        xAxis: {
            type: 'category',
            data: xData
        },
        yAxis: {
            type: 'value',
            name:'kWh'
        },
        legend: {
          icon:"rect",
          x:'right',
          itemHeight: 14,
          itemWidth: 14,
          itemGap: 10,
          textStyle:{
              fontSize: "16rem",//字体大小
          },
        },
        series: [{
            name:"充电电量",
            data:[0, 160, 160, 160, 160, 160, 160] ,
            type: 'bar',
            barWidth:15,
            itemStyle:{
                color:'#5B8FF9',
                barBorderRadius:[7,7,0,0]
            }
        },{
            name:"放电电量",
            data:[0, 160, 160, 160, 160, 160, 0] ,
            type: 'bar',
            barWidth:15,
            itemStyle:{
                color:'#5AD8A6',
                barBorderRadius:[7,7,0,0]
            }
        }],
        grid: {
            left: "0%",
            right: "0%",
            bottom: "4%",
            top: "15%",
            containLabel: true,
        },
        
        tooltip: {
            trigger: 'axis'
        },
    }
    },
  },
};
</script>
<style lang="less" scoped>
.diagram {
  height: 100%;
  justify-content: space-between;
  flex-wrap: nowrap;

  .box {
    background: #ffffff;
    .w(592);
    height: 100%;
    padding: 18rem;
  }

  .title {
    font-size: 16rem;
    font-weight: bold;
    margin-bottom: 10rem;
    justify-content: space-between;

    .tag {
      label {
        color: #333;
        cursor: pointer;
        margin-left: 12px;
        position: relative;
      }

      .active {
        color: #0E9CFF;
      }

      .active::before {
        content: "";
        border-top: 2px solid #0E9CFF;
        position: absolute;
        top: -22rem;
        width: 100%;
      }
    }
  }

  .el-dropdown {
    color: #333;
    float: right;
    font-weight: 400;
  }

  .cont {
    justify-content: space-between;
    .h(250);
    width: 100%;

  }
}
</style>